import { api } from 'api'

type GetShiftLeadEligibilityRequest = {
  companyId: number
}

type GetShiftLeadEligibilityResponse = {
  canCreateShiftLeads: boolean
}

export async function getShiftLeadEligibility(
  { companyId }: GetShiftLeadEligibilityRequest,
  signal?: AbortSignal
) {
  const response = await api.get<GetShiftLeadEligibilityResponse>(
    `/company/${companyId}/shifts/shift_lead_eligibility`,
    { signal }
  )

  return response.data
}
